import { getLabelFallback } from '@utils/utils';
import { ReactElement, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '@redux-actions/';
import { preparePayment, submitPayment } from '@utils/services';
import { useNavigate, useLocation } from 'react-router';
import { convertNumber, handleHTTPError } from '@utils/utils';

import PayPalButton from '@components/PayPalButton';
import PayPalModal from '@components/PayPalModal';

const PayPalCard = () : ReactElement => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { search } = useLocation();

    const isMobile = useSelector(state => state.cart.isMobile);
    const config = useSelector(state => state.cart.config);
    const cart = useSelector(state => state.cart.cart);

    const [payPalLogged, setPayPalLogged] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const label = getLabelFallback('PAYPAL_TEXT_LABEL_PART1')
        .replace('{SITE_NAME}', getLabelFallback('SITE_NAME'));

    const orderId = config.onBehalfSession === true && !!cart && !!cart.orderId ? { 'orderId': cart.orderId} : {}

    const openPayPalModal = () => {
        setShowModal(true);
        dispatch(actions.setModal(true));
    }

    useEffect(() => {
        if(!!cart && !!cart.paymentInstruction && cart.paymentInstruction.length > 0 && cart.paymentInstruction[0].payMethodId === 'PayPal') {
            setPayPalLogged(true);
            dispatch(actions.setEmail(cart.orderItem[0].email1));
        } else {
            setPayPalLogged(false);
        }
    }, [cart]);

    const content = !payPalLogged ? 
                            <span>
                                {getLabelFallback('PAYPAL_REDIRECT')}
                            <button className="primary-button" onClick={openPayPalModal} aria-label= {getLabelFallback('LEARN_MORE_RESUME_INSTALMENTS_LABEL')}>
                                {getLabelFallback('LEARN_MORE_RESUME_INSTALMENTS_LABEL')}
                            </button>
                            </span>
                         :
                        <>
                            <span>{getLabelFallback('PAYPAL_ACCOUNT_LABEL').toUpperCase()} {!!cart && !!cart.paymentInstruction && cart.paymentInstruction.lenght > 0 && cart.paymentInstruction[0].email1}</span>
                            <span>{getLabelFallback('PAYPAL_AMOUT_LABEL').toUpperCase()}: {getLabelFallback('CURRENCY_LABEL')}{convertNumber(cart.grandTotal)}</span>
                        </>;
    
    const cta = !payPalLogged ? 
                    <PayPalButton onApproveUrl={config.paypal.PAYPAL_CHECKOUT_URL} onReturnUrl={config.paypal.PAYPAL_RETURN_URL} smartGlassesError={''}/> :
                    <button aria-label={getLabelFallback('PAYPAL_CONFIRM_PAYMENT_LABEL')} className="violet-button" onClick={(e) => doPayment(e)}>{getLabelFallback('PAYPAL_CONFIRM_PAYMENT_LABEL')}</button>;

    const doPayment = (e) => {
        e.preventDefault();
        dispatch(actions.startLoading());
        preparePayment(config.hostname, orderId)
            .then((res: any) => {
              if(res.status === 200) {

                const submitPaymnetData = {
                  "orderId": cart.orderId,
                  "notifyOrderSubmitted": "1",
                  "notifyMerchant": "1",
                  "notifyShopper": "1",
                  "notify_EMailSender_recipient": "",
                  "purchaseorder_id": ""
                }

                submitPayment(config.hostname, submitPaymnetData)
                  .then((res: any) => {
                    localStorage.setItem('paymentIdPaypal',"PayPalExpressCheckout");
                    dispatch(actions.startLoading());
                    dispatch(actions.setOrderId(res.data.orderId));
                    if(typeof $TB != 'undefined' && !!$TB.hooks) {
                        $TB.hooks.fireEvent("pageChange", null, {"sendBeacon": true});
                    }
                    navigate(config.pagesUrl.typ + search);
                  })
                  .catch(err => {
                    console.error('>>> Paypal submit payment => error status:', err.status, ', error: ', err);
                    handleHTTPError(dispatch, actions, err);
                    dispatch(actions.errorLoading())
                  })
                }
            })
            .catch(err => {
                console.error('>>> Paypal prepare payment => error status:', err.status, ', error: ', err);
                handleHTTPError(dispatch, actions, err);
              dispatch(actions.errorLoading())
            })
    }

    const closePayPalModal = () => {
        setShowModal(false);
        dispatch(actions.setModal(false));
    }

    return(
        <div className="paypal-card">
            <div className="paypal-card-top">
                { content }
            </div>
            <div className="paypal-card-bottom">
                {cta}
                {showModal && <PayPalModal close={closePayPalModal} />}
            </div>
        </div>
    )
}

export default PayPalCard;